import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App.tsx";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 30-second stale time matches the feed's ~1-2 min refresh cadence
      staleTime: 30_000,
      retry: 2,
    },
  },
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found in DOM.");
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/*
        `useTransitions={false}`: navigations update state synchronously rather
        than inside a React `startTransition`. The shared-element morph (see
        lib/morph.ts) drives the route change through `flushSync` so the
        destination DOM is committed before the View Transition snapshots it —
        and `flushSync` cannot flush an update that is itself a transition. The
        app's routes render lightly, so opting out of navigation transitions
        costs nothing here.
      */}
      <BrowserRouter useTransitions={false}>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
